<template>

        <form @submit="submit" class="item-editor-form">
    
            <fg-input v-model="item.message" :label="$t('message_template.message')"></fg-input>

            <FormButtons
                @submit="submit"
                :reset="false" 
                :remove="action == 'edit'"
                :itemid="this.item.id+''"
                @remove="remove">
            </FormButtons>

            <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />

        </form> 
        
</template>

<script>

import FormButtons from '@/components/Misc/FormButtons'
import messagetemplates from '@/store/dispatching/messagetemplates'

export default {
    components: {
        FormButtons
    },
    props: {
        messageType: {
          type: String,
          required: true,
          validator( value ) {
            return ['DRIVER','DRIVER_ANNOUNCEMENT'].includes(value)
          }
        },
        item: {        
            default: function () {
                return {
                        "id": null,
                        "order":null,
                        "message": ""
                }
            }        
         },
        action: { default: "new" }
    },
    data: function() {
        return  {
            ok: false,
            error: false,
            loading: false,
            infoType: "save"
        }
    },    
    watch: {
        item(){
            this.ok = this.error = this.loading = false;            
        } 
    },
    methods: {
        submit(event) {
            if( event ) 
                event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => {
                const saveItem = { ...this.item }
                saveItem.type = this.messageType
                this.$store.dispatch('messagetemplates/saveDriverTemplate' , saveItem ).then(
                (response) => {
                    this.ok = response.data.errorCode == 0
                    this.error = !this.ok
                    this.loading = false
                },
                ()=>{
                    this.error = true; 
                });
            }, 1000);
        },
        reset(event){
            event.preventDefault();
            this.item = {
                        "id": null,
                        "order":null,
                        "message": "",
                        "type": this.messageType
                };              
        },
        remove() {
            this.infoType = "delete";
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch('messagetemplates/deleteDriverMessage' , { id : this.item.id , type: this.messageType }).then(
                (response) => {
                    this.ok = response.data.errorCode == 0
                    this.error = !this.ok
                    this.loading = false
                },
                ()=>{
                    this.error = true; 
                });
            }, 1000);
        }
    },
    created() {
        if (!this.$store.state.messagetemplates) {
            this.$store.registerModule("messagetemplates" , messagetemplates);
        }
        this.ok = this.error = this.loading = false;            
            
    }
}

</script>

